import {
  TABLE_MANAGEMENT_VOID_ITEM_REPORT_SET_OUTLETS,
  TABLE_MANAGEMENT_VOID_ITEM_REPORT_SET_LIST,
  TABLE_MANAGEMENT_VOID_ITEM_REPORT_SET_SUMMARY,
  TABLE_MANAGEMENT_VOID_ITEM_REPORT_SET_ITEM,
  TABLE_MANAGEMENT_VOID_ITEM_REPORT_SET_CURRENT_PAGE,
  TABLE_MANAGEMENT_VOID_ITEM_REPORT_SET_TOTAL_PAGE,
  TABLE_MANAGEMENT_VOID_ITEM_REPORT_PAGE_REQUEST,
  TABLE_MANAGEMENT_VOID_ITEM_REPORT_LIST_REQUEST,
  TABLE_MANAGEMENT_VOID_ITEM_REPORT_CHANGE_FILTER,
  TABLE_MANAGEMENT_VOID_ITEM_REPORT_EXPORT,
} from './constants';

export function setOutlets(outlets) {
  return {
    type: TABLE_MANAGEMENT_VOID_ITEM_REPORT_SET_OUTLETS,
    payload: { outlets },
  };
}
export function setReports(reports) {
  return {
    type: TABLE_MANAGEMENT_VOID_ITEM_REPORT_SET_LIST,
    payload: { reports },
  };
}

export function setReportDetail(report) {
  return {
    type: TABLE_MANAGEMENT_VOID_ITEM_REPORT_SET_ITEM,
    payload: { report },
  };
}

export function setReportSummary(reportSummary) {
  return {
    type: TABLE_MANAGEMENT_VOID_ITEM_REPORT_SET_SUMMARY,
    payload: { reportSummary },
  };
}

export function setReportsCurrentPage(currentPage) {
  return {
    type: TABLE_MANAGEMENT_VOID_ITEM_REPORT_SET_CURRENT_PAGE,
    payload: { currentPage },
  };
}

export function setReportsTotalPage(totalPage) {
  return {
    type: TABLE_MANAGEMENT_VOID_ITEM_REPORT_SET_TOTAL_PAGE,
    payload: { totalPage },
  };
}

export function voidItemReportPageRequest() {
  return { type: TABLE_MANAGEMENT_VOID_ITEM_REPORT_PAGE_REQUEST };
}

export function voidItemReportListRequest(payload) {
  return { type: TABLE_MANAGEMENT_VOID_ITEM_REPORT_LIST_REQUEST, payload };
}

export function voidItemReportChangeFilter(payload) {
  return { type: TABLE_MANAGEMENT_VOID_ITEM_REPORT_CHANGE_FILTER, payload };
}

export function voidItemReportExport(payload) {
  return { type: TABLE_MANAGEMENT_VOID_ITEM_REPORT_EXPORT, payload };
}
